import logo from './logo.svg';
import BracketSpacer from './components/BracketSpacer.jsx';
import useDeviceInfo from "./hooks/useDeviceInfo";
import './App.css';

function App() {
  const { deviceType, orientation } = useDeviceInfo();
  return (
    <div >

        <BracketSpacer/>
    </div>
  );
}

export default App;
